import { render, staticRenderFns } from "./pgallcategories.vue?vue&type=template&id=67afa701&"
import script from "./pgallcategories.vue?vue&type=script&lang=js&"
export * from "./pgallcategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports